import { render, staticRenderFns } from "./RedeemPrizesView.vue?vue&type=template&id=e5cd4454&scoped=true&"
import script from "./RedeemPrizesView.vue?vue&type=script&lang=js&"
export * from "./RedeemPrizesView.vue?vue&type=script&lang=js&"
import style0 from "./RedeemPrizesView.vue?vue&type=style&index=0&id=e5cd4454&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cd4454",
  null
  
)

export default component.exports